export default __webpack_public_path__ + "static/media/promo-3.849588a2.png";